export default "__VITE_ASSET__651ca523__"